// Packages:
import { useState } from "react"

// Components:
import CoursesAccordian from "../coursesAccordian"

// Typescript:
import { courseDataType } from "../../pages/details"

interface courseModulePropsType {
    courseData: courseDataType | undefined
}

export interface weekType {
    title: string
    time: string
    points: {
        title: string 
    }[]
}
const CourseModule = ({courseData}:courseModulePropsType) => {
    // States:
    const [isExpanded, setIsExpanded] = useState(false)

    return <div className='col-[2_/_3] w-full my-[5rem]'>
        <h2 className='text-[30px] md:text-[40px] font-extrabold mb-[15px]'>{`There are ${courseData?.course?.length} modules in this course`}</h2>
        <p className=' text-[#8F8E8E] text-[18px] leading-[24px] w-full lg:w-[60%]'>

            {(courseData?.longDesc?.length ?? 1) > 150 ? (
                isExpanded ?  courseData?.longDesc :  courseData?.longDesc.slice(0, 150) + ((courseData?.longDesc?.length ?? 1) > 150 ? '...' : '')
            ) : (
                courseData?.longDesc
            )}
        </p>
        <div className='mt-[10px] text-[#FF6D28] text-[20px] font-bold cursor-pointer w-max' onClick={()=>setIsExpanded(!isExpanded)}>
            {
           (courseData?.longDesc?.length ?? 1) > 150 ? (
            isExpanded ? 'Read less' : 'Read more'
           ) : ('')
        }</div>

        <div className='mt-[30px] bg-[#F5F5FF] rounded-[30px] p-[25px] w-full lg:w-[60%]'>
            {courseData?.course?.map((week:weekType, index:number)=> 
                <CoursesAccordian 
                    key={index}
                    week={week} 
                    index={index} 
                /> )}
        </div>
    </div>
}

export default CourseModule